import { render, staticRenderFns } from "./ResultContinueBonus.vue?vue&type=template&id=366f344b&scoped=true"
import script from "./ResultContinueBonus.vue?vue&type=script&lang=js"
export * from "./ResultContinueBonus.vue?vue&type=script&lang=js"
import style0 from "./ResultContinueBonus.vue?vue&type=style&index=0&id=366f344b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f344b",
  null
  
)

export default component.exports